import React from 'react';
import { ResourceMatchResult } from '@/types/recommendation';
import { Badge } from '@/components/ui/badge';
import { ResourceRecommendationCard } from './ResourceRecommendationCard';

interface RecommendedResourceListProps {
  results: ResourceMatchResult[];
  pendingResourceIds: string[];
  requestedStart: Date;
  requestedEnd: Date;
  onAdd: (result: ResourceMatchResult) => void;
  onRemove?: (result: ResourceMatchResult) => void;
  requiredSkills?: string[];
}

export function RecommendedResourceList({
  results,
  pendingResourceIds,
  requestedStart,
  requestedEnd,
  onAdd,
  onRemove,
  requiredSkills = [],
}: RecommendedResourceListProps) {
  if (results.length === 0) return null;

  return (
    <div className="space-y-1.5" role="region" aria-label="Resource suggestions">
      <div className="flex items-center gap-2 pb-0.5">
        <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">
          Best matches
        </span>
        <Badge variant="secondary" className="text-[10px] px-1.5 py-0 h-4">
          {results.length}
        </Badge>
      </div>
      {results.map((r, idx) => (
        <ResourceRecommendationCard
          key={r.resource.id}
          result={r}
          isAlreadyAdded={pendingResourceIds.includes(r.resource.id)}
          isPreSelected={false}
          onAdd={onAdd}
          onRemove={onRemove}
          requestedStart={requestedStart}
          requestedEnd={requestedEnd}
          requiredSkills={requiredSkills}
        />
      ))}
    </div>
  );
}
